import { render, staticRenderFns } from "./StockTrackingDetails.vue?vue&type=template&id=51da3eec&"
import script from "./StockTrackingDetails.vue?vue&type=script&lang=js&"
export * from "./StockTrackingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports